export default __webpack_public_path__ + "static/media/401a_light.647d23ad.png";